import * as React from 'react';
import { IonPainter } from '../../api/IonPainter';
import './Canvas.css';

export class Canvas extends React.Component {
  componentDidMount (): void {
    const canvasContainer = document.getElementById('canvas-container');
    const ionPainter = new IonPainter(canvasContainer);
    ionPainter.show();
  }

  render (): React.ReactNode {
    return (
      <div id='canvas-container'></div>
    );
  }
}
